// extracted by mini-css-extract-plugin
module.exports =  {"item":"a10a3f92e9--item--SRLfK"};